"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.daysAboveMaps = void 0;
exports.daysAboveMaps = [40104, 40303, 40106, 40301, 40302, 40304, 40107, 40105];
